import React from 'react';
import type { Locales } from 'cms/cms-types';
import { type Filter, type ListingFiltersState } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { type ListingPaginationState } from '3-components/ListingApp/ListingPagination/ListingPagination';
import { type ListingUILabel } from '3-components/ListingApp/ListingUI/ListingUI';

export type AppStatus = 'initial-loading' | 'fetching' | 'initial-error' | 'error' | 'ready';

export interface ArticleListingLabel extends ListingUILabel {
    title: string;
    clearFilterButton: string;
    minReadSuffix: string;
}

export interface ArticleListingCMSConfig {
    apiUrl?: string;
    apiKey: string;
}

export interface ArticleListingProps {
    locale?: Locales;
    cms: ArticleListingCMSConfig;
    label: ArticleListingLabel;
    listing: {
        filters?: Filter[];
        filterByAncestors?: string[];
        itemsPerPage: number;
    };
}

export interface ArticleListingContextProps extends ArticleListingProps, ListingFiltersState, ListingPaginationState {
    // appStatus: AppStatus;
    // setAppStatus: React.Dispatch<React.SetStateAction<AppStatus>>;
    // errorMessage: string;
    // setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

const ArticleListingContext = React.createContext<Partial<ArticleListingContextProps>>({});

export default ArticleListingContext;
